import { render, staticRenderFns } from "./CurrencyItem.vue?vue&type=template&id=6ae2a68b&scoped=true&"
import script from "./CurrencyItem.vue?vue&type=script&lang=js&"
export * from "./CurrencyItem.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyItem.vue?vue&type=style&index=0&id=6ae2a68b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae2a68b",
  null
  
)

export default component.exports